exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "what-is-solidary-list .solidarity-list{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}what-is-solidary-list .solidarity-list .card-list{flex:auto;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryList/whatIsSolidaryList.scss
// module id = 2257
// module chunks = 0